import type { Logger } from "./types";

export type { Logger, LogContext, LogLevel } from "./types";

export const getLogger = (): Logger => {
  if (typeof window === "undefined") {
    // dynamic require to avoid bundling server-only code into client bundles
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require("./logger.server").logger as Logger;
  }
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require("./logger.client").logger as Logger;
};

export const logger: Logger = getLogger();

export const getLoggerForComponent = (component: string): Logger => {
  return getLogger().child({ component });
};
